import axios from "axios";

export const postRequest = (path: string, requestBody: {}) => {
  return axios.post(path, requestBody);
};
